var _languageInfos$;

import React from 'react';
import enJson from './locales/en-US';
import zhJson from './locales/zh-CN';
import twJson from './locales/zh-TW';
import idJson from './locales/id-ID';
import myJson from './locales/ms-MY';
import vnJson from './locales/vi-VN';
import thJson from './locales/th-TH';
export var languageInfos = [{
  name: 'zh-CN',
  value: zhJson,
  label: '简体中文'
}, {
  name: 'en-US',
  value: enJson,
  label: '英语'
}, {
  name: 'zh-TW',
  value: twJson,
  label: '繁体中文'
}, {
  name: 'id-ID',
  value: idJson,
  label: '印尼语'
}, {
  name: 'ms-MY',
  value: myJson,
  label: '马来语'
}, {
  name: 'vi-VN',
  value: vnJson,
  label: '越南语'
}, {
  name: 'th-TH',
  value: thJson,
  label: '泰语'
}];
var language = (_languageInfos$ = languageInfos[0]) === null || _languageInfos$ === void 0 ? void 0 : _languageInfos$.name;

var getDefault = function getDefault(key) {
  if (key && key.split('.').length) {
    var names = key.split('.').filter(Boolean);
    return names[names.length - 1];
  }

  return key;
};

var getTargetJson = function getTargetJson() {
  var _languageInfos$find;

  return ((_languageInfos$find = languageInfos.find(function (item) {
    return item.name === language;
  })) === null || _languageInfos$find === void 0 ? void 0 : _languageInfos$find.value) || zhJson;
};

export var getValue = function getValue(_ref) {
  var key = _ref.key,
      params = _ref.params;
  var value = getTargetJson()[key] || getDefault(key) || '';

  if (params) {
    return value.replace(/\{\{.*?\}\}/g, function (target) {
      var param = target.replace(/(\{\{)|(\}\})/g, '').trim();
      return params[param] || '';
    });
  }

  return value;
};
export var getLanguage = function getLanguage() {
  return language;
};
export var changeLanguage = function changeLanguage(lang) {
  if (language !== lang) {
    language = lang;
    Array.from(document.querySelectorAll('.sl-admin-components-i18n')).forEach(function (item) {
      item.innerHTML = getValue(JSON.parse(item.getAttribute('placeholder') || '{}'));
    });
  }
};
export var i18n = function i18n(key, params) {
  return /*#__PURE__*/React.createElement("span", {
    key: key,
    className: "sl-admin-components-i18n",
    placeholder: JSON.stringify({
      key: key,
      params: params
    })
  }, getValue({
    key: key,
    params: params
  }));
};
export var useI18n = function useI18n(prefix) {
  return function (key) {
    return i18n("".concat(prefix, ".").concat(key));
  };
};
export default changeLanguage;